// import React from 'react'

// function Contact() {
//   return (
//     <div>
//           <h2 className="text-2xl font-semibold mb-6">Contact Us</h2>
//           <form className="space-y-4">
//             <input
//               type="text"
//               placeholder="Your Name"
//               className="w-full p-3 rounded-md bg-gray-800 border border-gray-700 focus:ring-2 focus:ring-blue-500"
//               required
//             />
//             <input
//               type="email"
//               placeholder="Your Email"
//               className="w-full p-3 rounded-md bg-gray-800 border border-gray-700 focus:ring-2 focus:ring-blue-500"
//               required
//             />
//             <textarea
//               placeholder="Your Message"
//               className="w-full p-3 h-32 rounded-md bg-gray-800 border border-gray-700 focus:ring-2 focus:ring-blue-500"
//               required
//             />
//             <button
//               type="submit"
//               className="bg-green-600 hover:bg-green-700 px-6 py-3 rounded-md font-semibold transition w-full"
//             >
//               Submit
//             </button>
//           </form>
//         </div>
//   )
// }

// export default Contact


// import React from 'react';

// function Contact() {
//   return (
//     <div className="container mx-auto px-4 mt-20">
//       <div className="max-w-3xl mx-auto text-left">
//         <h2 className="text-3xl font-bold mb-4 text-gray-800">
//           Let’s Talk About Your Data Goals
//         </h2>
//         <p className="text-gray-600 mb-8">
//           Whether you’re curious about how data can help your business grow, or ready to build something powerful — we’re here to help.
//           Reach out and let’s start the conversation.
//         </p>

//         <form className="space-y-5">
//           <input
//             type="text"
//             placeholder="Your Name"
//             className="w-full p-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
//             required
//           />
//           <input
//             type="email"
//             placeholder="Your Email"
//             className="w-full p-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
//             required
//           />
//           <textarea
//             placeholder="Your Message"
//             className="w-full p-3 h-32 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
//             required
//           />
//           <button
//             type="submit"
//             className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md font-semibold transition"
//           >
//             Send Message
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// }

// export default Contact;

import React, { useState } from 'react';
import contact_us from '../assets/contact_us.jpg'
import FooterVideo from './FooterVideo';
import Footer from './Footer';
import emailjs from "@emailjs/browser";

const industries = [
  'Technology',
  'Finance',
  'Healthcare',
  'Retail',
  'Manufacturing',
  'Education',
  'Other',
];

const interests = [
  'Data Strategy Consulting',
  'Business Intelligence',
  'AI & Machine Learning',
  'Data Visualisation',
  'Project Management',
  'Website Development',
  'Other',
];

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    company: '',
    industry: '',
    interest: '',
    contactPermission: false,
  });

  // const emailjs = require("emailjs-com");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    // // handle form submit logic here
    // console.log(formData);
    // alert('Form submitted! Thank you.');
    // if (e === undefined) return;
    // e.preventDefault();
    // setLoading(true);

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          from_name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message,
          company: formData.company,
          industry: formData.industry,
          interest: formData.interest,
          contactPermission: formData.contactPermission ? "Yes" : "No",
          to_email: 'info@jyotinayanalytics.com'
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          setLoading(false);
          alert("Thank you. I will get back to you as soon as possible.");

          setFormData({
            name: '',
            email: '',
            phone: '',
            message: '',
            company: '',
            industry: '',
            interest: '',
            contactPermission: false
          });
        }, (error) => {
          setLoading(false);
          console.log(error);
          alert("Something went wrong.");
        }
      );
  };

//   const handleSubmit = async (e) => {
//   e.preventDefault();

//   const res = await fetch("../api/sendEmail", {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(formData),
//   });

//   if (res.ok) {
//     alert("Thank you. I will get back to you soon.");
//     setFormData({
//       name: '', email: '', phone: '', message: '', company: '',
//       industry: '', interest: '', contactPermission: false,
//     });
//   } else {
//     alert("Something went wrong.");
//   }
// };

  return (
    <div>
      {/* <Navbar /> */}
      {/* Hero Section with image */}
      <div className="relative mt-24">
        <img
          src={contact_us}
          alt="Contact Jyoinay Analytics"
          className="w-full h-64 md:h-[30rem] object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center px-4 text-center">
          <h1 className="text-white text-3xl md:text-5xl font-bold py-14 mt-16">
            Get in Touch with Jyotinay Analytics
          </h1>
          <p className="text-white max-w-3xl text-sm md:text-lg">
            Whether you have questions about our services or want to explore how data can transform your business,
            we’re here to help. Fill out the form below and let’s start a conversation.
          </p>
        </div>

        {/* Contact form overlapping bottom of image */}
        <form
          onSubmit={handleSubmit}
          className="bg-white shadow-lg rounded-lg p-8 max-w-6xl mx-auto
          -mt-20 md:-mt-28 relative z-10 grid grid-cols-1 md:grid-cols-2 gap-8"
        >
          {/* Left Column */}
          <div className="flex flex-col space-y-6">
            <div>
              <label htmlFor="name" className="block mb-2 font-medium text-gray-700">
                Name <span className="text-red-500">*</span>
              </label>
              <input
                required
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-blue-600"
                placeholder="Your full name"
              />
            </div>

            <div>
              <label htmlFor="email" className="block mb-2 font-medium text-gray-700">
                Email <span className="text-red-500">*</span>
              </label>
              <input
                required
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-blue-600"
                placeholder="you@example.com"
              />
            </div>

            <div>
              <label htmlFor="phone" className="block mb-2 font-medium text-gray-700">
                Phone Number (optional)
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-blue-600"
                placeholder="+1 234 567 890"
              />
            </div>

            <div className="flex flex-col">
              <label htmlFor="message" className="block mb-2 font-medium text-gray-700">
                Message <span className="text-red-500">*</span>
              </label>
              <textarea
                required
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows={6}
                className="w-full border border-gray-300 rounded-md p-3 resize-none focus:outline-none focus:ring-2 focus:ring-blue-600"
                placeholder="Write your message here..."
              />
            </div>
          </div>

          {/* Right Column */}
          <div className="flex flex-col space-y-6">
            <div>
              <label htmlFor="company" className="block mb-2 font-medium text-gray-700">
                Company Name (optional)
              </label>
              <input
                type="text"
                id="company"
                name="company"
                value={formData.company}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-blue-600"
                placeholder="Your company"
              />
            </div>

            <div>
              <label htmlFor="industry" className="block mb-2 font-medium text-gray-700">
                Industry (optional)
              </label>
              <select
                id="industry"
                name="industry"
                value={formData.industry}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-blue-600"
              >
                <option value="">Select an industry</option>
                {industries.map((ind) => (
                  <option key={ind} value={ind}>
                    {ind}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label htmlFor="interest" className="block mb-2 font-medium text-gray-700">
                Area of Interest
              </label>
              <select
                id="interest"
                name="interest"
                value={formData.interest}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-blue-600"
              >
                <option value="">Select an area</option>
                {interests.map((int) => (
                  <option key={int} value={int}>
                    {int}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex items-center space-x-3 mt-6">
              <input
                type="checkbox"
                id="contactPermission"
                name="contactPermission"
                checked={formData.contactPermission}
                onChange={handleChange}
                className="w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-2 focus:ring-blue-600"
              />
              <label htmlFor="contactPermission" className="text-gray-700 select-none">
                I agree to be contacted via phone or email.
              </label>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="mt-auto bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-md transition"
            >
              {loading ? "Sending..." : "Send Message"}
            </button>
          </div>
        </form>
      </div>
      <FooterVideo />
      <Footer />
    </div>
  );
};

export default ContactPage;
